import { render, staticRenderFns } from "./CreateSteps.vue?vue&type=template&id=284dea88&scoped=true"
import script from "./CreateSteps.vue?vue&type=script&lang=ts"
export * from "./CreateSteps.vue?vue&type=script&lang=ts"
import style0 from "./CreateSteps.vue?vue&type=style&index=0&id=284dea88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284dea88",
  null
  
)

export default component.exports